import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { InternationalizationService } from 'app/shared/services/internationalization.service';
import { LanguageService, TranslatedLanguage } from 'app/shared/services/language.service';

@Component({
  selector: 'app-language-modal',
  templateUrl: 'language-modal.component.html',
  styleUrls: ['language-modal.component.scss']
})
export class LanguageModalComponent {
  public languages: Array<TranslatedLanguage> = [];
  public loading: boolean;

  constructor(
    private internationalizationService: InternationalizationService,
    public dialogRef: MatDialogRef<LanguageModalComponent>,
    public language: LanguageService
  ) {

    this.loadLanguage();
  }

  useLanguage(i: string): void {
    this.language.change(this.languages[ i ]);
    this.internationalizationService.changeLanguage(this.languages[ i ]);

    this.loadLanguage(i);

    this.dialogRef.close(undefined);
  }

  loadLanguage(i?: string): void {
    this.loading = true;

    this.internationalizationService.getLanguages().then((data: TranslatedLanguage[]) => {
      this.loading = false;

      if (data[ 'count' ]) {
        this.languages = data[ 'items' ];
        if (i != null) {
          this.language.saveCookie(this.languages[ i ]);
          this.language.change(this.languages[ i ]);
          this.languages[ i ].code;
          // window.location.reload();
        }
      }
    });
  }
}
